import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';

import ImageDisplay from '../../imageDisplay';

const ArticleCard = ({ article }) => {
	return (
		<div className="card article-card">
			<div className="card__head">
				<ImageDisplay
					className="card__head-image"
					alt={article.headerImage?.alt}
					image={article.headerImage?.data}
					src={article.headerImage?.src}
				/>
			</div>
			<div className="card__body">
				<span className="typography typography--overline">
					{article.category}
				</span>
				<h3 className="typography typography--h4">{article.title}</h3>
				<p className="typography typography--body-bold">{article.date}</p>
				<div
					className="typography typography--body-big"
					dangerouslySetInnerHTML={{
						__html: article.body,
					}}
				/>
				<Link
					to={`${article.link}/`}
					className="article-card__link btn btn--outlined"
				>
					View article
				</Link>
			</div>
		</div>
	);
};

ArticleCard.propTypes = {
	article: PropTypes.shape({
		category: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		date: PropTypes.string.isRequired,
		body: PropTypes.string.isRequired,
		link: PropTypes.string.isRequired,
		headerImage: PropTypes.shape({
			data: PropTypes.object,
			src: PropTypes.string,
			alt: PropTypes.string,
		}),
	}).isRequired,
};

export default ArticleCard;
